@for (tab of visibleTabs(); track tab) {
  <button
    #tabButton
    class="tab"
    [ngClass]="{ selected: isTabSelected(tab), disabled: tab.isDisabled() }"
    [disabled]="tab.isDisabled()"
    [matTooltip]="tab.disabledTooltip()"
    [matTooltipDisabled]="!tab.isDisabled()"
    (click)="setSelectedTab(tab)">
    @if (tab.icon()) {
      <mat-icon>{{ tab.icon() }}</mat-icon>
    }
    @let tabContent = tab.content();
    @if (typeof tabContent === 'string') {
      {{ tabContent }}
    } @else {
      <ng-container *ngTemplateOutlet="tabContent"></ng-container>
    }
  </button>
}

<ng-template #content>
  @for (tab of visibleTabs(); track tab) {
    <!-- Preload all tabs that are not lazy -->
    @if (!tab.lazy() || cachedTabs.has(tab) || isTabSelected(tab)) {
      <div
        class="tab-projection"
        [hidden]="!isTabSelected(tab)">
        <ng-container *ngTemplateOutlet="tab.template"></ng-container>
      </div>
    }
  }
</ng-template>
